module.exports = __webpack_public_path__ + "img/获取账户信息.d895b74b.jpg";